import Vue from 'vue';
import Router from 'vue-router';
import BootstrapVue from 'bootstrap-vue';

// import AuthService from './common/auth.service';

Vue.use(Router);
Vue.use(BootstrapVue);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/Home'),
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: () => import('@/views/PrivacyPolicy'),
    },
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: () => import('@/views/authentication/Login'),
    // },
  ],
  scrollBehavior (to) {
    document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
  }

});

function setActive() {
  setTimeout(() => {
    removeHash();
  }, 1);

  function removeHash() {
    history.replaceState('', document.title, window.location.origin + window.location.pathname + window.location.search);
  }
}

// Ensure we checked auth before each page load.
// router.beforeEach((to, from, next) => AuthService.checkAuth(next, to));

router.afterEach(() => {
  setActive();
});

export default router;
